<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-投诉-修改（限制图片最多上传两张）
    -->
    <el-dialog
    title="修改投诉"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改投诉</div>
      
      <el-form-item label="投诉名称" prop="name"><el-input v-model="form.name" placeholder="请输入投诉名称" class="max-w460"></el-input></el-form-item>
      
      <!-- 视频选择 -->
      <el-form-item label="视频" prop="video">
        <div class="draggable-list">
          <div v-for="(item, index) in form.video" :key="index" class="item">
            <video :src="item.file_path" controls width="100" height="80"></video>
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteVideo(index)"><i class="el-icon-close"></i></a>
          </div>
          <div class="item img-select" @click="openVideoUpload">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>
      
      <!-- 状态选择 -->
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status" size="small">
          <el-radio label="未结单">未结单</el-radio>
          <el-radio label="已结单">已结单</el-radio>
          <el-radio label="处理中">处理中</el-radio>
          <el-radio label="已完成">已完成</el-radio>
        </el-radio-group>
      </el-form-item>
      
      <!-- 星星评分 -->
      <el-form-item label="星星" prop="star">
        <el-rate 
          v-model="form.star" 
          :max="5" 
          :allow-half="false"
          placeholder="请选择评分"
        ></el-rate>
        <span class="star-text">{{ form.star || 0 }} 星</span>
      </el-form-item>
        <el-form-item label="评价文字">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  
       <el-form-item label="所属平台分类：" prop="form.category_id">
      <el-select v-model="form.category_id">
        <template v-for="cat in catgoryx">
          <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name+('-'+cat.supply_name)"></el-option>
          <template v-if="cat.child !== undefined" v-for="two in cat.child">
            <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px"></el-option>
            <template v-if="two.child !== undefined" v-for="three in two.child">
              <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px"></el-option>
            </template>
          </template>
        </template>
      </el-select>
    </el-form-item>
      
      
      <el-form-item label="姓名" prop="nickname"><el-input v-model="form.nickname" placeholder="" class="max-w460"></el-input></el-form-item>
      <el-form-item label="联系方式" prop="phone"><el-input v-model="form.phone" placeholder="" class="max-w460"></el-input></el-form-item>
      
      <!-- 预计完成时间 -->
      <el-form-item label="预计完成时间" prop="timeRange">
        <el-time-select
          v-model="form.timeRange[0]"
          placeholder="开始时间"
          :picker-options="{
            start: '08:00',
            step: '00:30',
            end: '18:00'
          }"
        ></el-time-select>
        <span style="margin: 0 10px;">至</span>
        <el-time-select
          v-model="form.timeRange[1]"
          placeholder="结束时间"
          :picker-options="{
            start: '08:00',
            step: '00:30',
            end: '18:00'
          }"
        ></el-time-select>
      </el-form-item>
    
      
      <el-form-item label="投诉bannar：" prop="bannar">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.bannar">
            <transition-group>
              <div v-for="(item, index) in form.bannar" :key="item.file_path">
                <div class="item">
                  <img v-img-url="item.file_path" alt="bannar图片"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')"><i class="el-icon-close"></i></a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div 
            class="item img-select" 
            @click="openProductUpload('bannar')"
            :class="{ 'disabled': form.bannar.length >= 2 }"
          >
            <i class="el-icon-plus"></i>
            <span class="upload-tip">最多2张</span>
          </div>
        </div>
      </el-form-item>


      <el-form-item label="投诉图片：" prop="image">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.image">
            <transition-group>
              <div v-for="(item, index) in form.image" :key="item.file_path">
                <div class="item">
                  <img v-img-url="item.file_path" alt="投诉图片"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')"><i class="el-icon-close"></i></a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div 
            class="item img-select" 
            @click="openProductUpload('album')"
            :class="{ 'disabled': form.image.length >= 2 }"
          >
            <i class="el-icon-plus"></i>
            <span class="upload-tip">最多2张</span>
          </div>
        </div>
      </el-form-item>

    

      <el-form-item label="排序" prop="sort"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    
    <!-- 图片上传组件 - 限制最多上传2张 -->
    <Upload v-if="isProductUpload" :config="{ total: 2 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    
    <!-- 视频上传组件 -->
    <Upload v-if="isVideoUpload" :config="{ total: 1, accept: 'video/*' }" :isupload="isVideoUpload" @returnImgs="returnVideoImgsFunc">上传视频
    </Upload>
    
  </div>
</el-dialog>
  
</template>

<script>
import Complaints_complaintsApi from '@/api/complaints_complaints.js';

import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {
     Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
      /*是否上传图片*/
      isProductUpload: false,
      /*是否上传视频*/
      isVideoUpload: false,
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        category_id:'',
        phone: '',
        // 时间范围数组
        timeRange: ['', ''],
        nickname: '',
        status: '', // 未结单、已结单、处理中、已完成
        star: 0, // 星星评分，0-5
        video: [], // 视频数组
        
        name: '',
        code: 'custom',
        image: [],
        sort: 50,
        intro: "",
        bannar: []
      },
       catgoryx:[],
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入投诉名称', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        star: [{ required: true, message: '请选择评分', trigger: 'change' }],
        timeRange: [
          { required: true, message: '请选择开始时间', trigger: 'change', validator: this.validateTimeRange }
        ]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      code: "album"
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
     this.getCategory()
  },
  props: ["open_add", "complaints_complaints_id"],
  methods: {
    // 验证时间范围
    validateTimeRange(rule, value, callback) {
      if (!value[0]) {
        return callback(new Error('请选择开始时间'));
      }
      if (!value[1]) {
        return callback(new Error('请选择结束时间'));
      }
      if (value[0] >= value[1]) {
        return callback(new Error('结束时间必须晚于开始时间'));
      }
      callback();
    },
    
    chooseCategory() {
      this.iscategorya = true;
    },
     getCategory(){
      var self = this
        Complaints_complaintsApi.getCategory()
            .then(res => {
             self.catgoryx = res.data.catgory
            })

            console.log('catgoryx',this.catgoryx);
            
    },
    
    // 打开视频上传
    openVideoUpload() {
      this.isVideoUpload = true;
    },
    
    // 处理上传的视频
    returnVideoImgsFunc(e) {
      if (e != null) {
        const videoExt = ["mp4", "webm", "ogg", "mov", "avi"];
        let isValid = false;
        
        e.forEach(element => {
          const dataArray = element.file_path.split(".");
          const ext = dataArray[dataArray.length - 1].toLowerCase();
          if (videoExt.includes(ext)) {
            isValid = true;
          }
        });

        if (!isValid) {
          this.$message.error("视频类型有误,请选择正确的视频格式(mp4,webm,ogg,mov,avi)");
          return false;
        }

        // 只保留一个视频
        this.form.video = e;
      }
      this.isVideoUpload = false;
    },
    
    // 删除视频
    deleteVideo(index) {
      this.form.video.splice(index, 1);
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    cancelFunc() { // 取消
      this.dialogFormVisible("error")
    },

    // 获取详情数据
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      Complaints_complaintsApi.detail({ complaints_complaints_id: self.complaints_complaints_id }, true)
        .then(res => {
          self.form = res.data;
          // 处理时间格式，将字符串转换为时间范围数组
          if (self.form.time) {
            const timeArr = self.form.time.split(' - ');
            self.form.timeRange = [timeArr[0], timeArr[1]];
          } else {
            self.form.timeRange = ['', ''];
          }
          // 初始化富文本内容
          self.ueditor.text = self.form.intro || '';
          // 确保数组存在
          if (!self.form.bannar) self.form.bannar = [];
          if (!self.form.image) self.form.image = [];
          if (!self.form.video) self.form.video = [];
          self.loading = false;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      
      // 处理时间格式
      form.time = form.timeRange[0] + ' - ' + form.timeRange[1];
      
      if (form.image.length <= 0) {
        self.$message({
          message: "请上传图片",
          type: 'error'
        });
        return;
      }
      
      form.intro = this.$refs.ue.getUEContent();
      form.complaints_complaints_id = self.complaints_complaints_id;
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Complaints_complaintsApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    /*打开上传图片 - 检查是否已达最大数量*/
    openProductUpload(code) {
      // 检查当前图片数量是否已达上限
      if ((code === 'album' && this.form.image.length >= 2) || 
          (code === 'bannar' && this.form.bannar.length >= 2)) {
        this.$message.warning('最多只能上传2张图片');
        return;
      }
      this.isProductUpload = true;
      this.code = code;
    },

    /*上传商品图片 - 限制最多2张*/
    returnProductImgsFunc(e) {
      if (this.code == 'album') {
        // 计算还能上传多少张图片
        const remaining = 2 - this.form.image.length;
        if (remaining <= 0) {
          this.$message.warning('最多只能上传2张图片');
          this.isProductUpload = false;
          return;
        }
        
        // 如果选择的图片数量超过剩余可上传数量，只取前remaining张
        const selectedImages = e.slice(0, remaining);
        
        if (selectedImages.length > 0) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          
          selectedImages.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(selectedImages);
          this.$set(this.form, "image", imgs);
        }
      } else {
        // 处理bannar图片，同样限制最多2张
        const remaining = 2 - this.form.bannar.length;
        if (remaining <= 0) {
          this.$message.warning('最多只能上传2张图片');
          this.isProductUpload = false;
          return;
        }
        
        const selectedImages = e.slice(0, remaining);
        
        if (selectedImages.length > 0) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          
          selectedImages.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(selectedImages);
          this.$set(this.form, "bannar", imgs);
        }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if (code == 'album') {
        this.form.image.splice(index, 1);
      } else if (code == 'bannar') {
        this.form.bannar.splice(index, 1);
      }
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img,
.draggable-list .item video {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border: 1px dashed #dddddd;
  font-size: 30px;
  cursor: pointer;
}

.draggable-list .img-select i {
  color: #409eff;
  margin-bottom: 5px;
}

.draggable-list .img-select.disabled {
  border-color: #ccc;
  cursor: not-allowed;
}

.draggable-list .img-select.disabled i {
  color: #ccc;
}

.upload-tip {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
}

/* 星星评分文本样式 */
.star-text {
  margin-left: 10px;
  color: #666;
}

/* 单选框样式调整 */
.el-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/complaints_complaints/index/part/edit.vue